import { Autocomplete } from "@material-ui/lab";
import { DefaultTextField } from "./EditCustomerPage";
import LogoSection from "../../../components/UploadLogo";
import { TextField, Button } from "@material-ui/core";
import { getNonEmpty } from "../../../../utils/helpers";
import { useEffect, useState } from "react";
import { alertError } from "../../../../utils/logger";
import { getCountries } from "../../../../api/country";
import { getAllActiveAdvisorServices } from "../../../../api/advisorService";
import { getAllActiveBusinessAreas } from "../../../../api/businessArea";
import { getAllActiveTechnologies } from "../../../../api/technology";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { format } from "date-fns";

export function CustomerTab({ customer, setCustomer, rolePathSingle, logo, openLogo }) {
    const { selectedLogo, setSelectedLogo } = logo;
    const { openPreviewDialog, setOpenPreviewDialog } = openLogo;

    const [countries, setCountries] = useState([]);
    const [advServices, setAdvServices] = useState([]);
    const [businessArea, setBusinessArea] = useState([]);
    const [technologiesAd, setTechnologiesAd] = useState([]);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [actionType, setActionType] = useState(null);

    const [openTermsDialog, setOpenTermsDialog] = useState(false);

    const isAdvisorMA = customer?.advisorService?.some(adS => adS?.title?.en?.includes("M&A"));


    useEffect(() => {
        getCountries()
            .then((res) => { setCountries(res.data) })
            .catch((error) => { alertError({ error: error, customMessage: "Could not get countries." }); })


        if (rolePathSingle !== 'advisor')
            return;

        getAllActiveAdvisorServices()
            .then((res) => { setAdvServices(res.data) })
            .catch((error) => { alertError({ error: error, customMessage: "Could not get advisor services." }); })

        getAllActiveBusinessAreas()
            .then((res) => { setBusinessArea(res.data) })
            .catch((error) => { alertError({ error: error, customMessage: "Could not get business area." }); })


        getAllActiveTechnologies()
            .then((res) => { setTechnologiesAd(res.data) })
            .catch((error) => { alertError({ error: error, customMessage: "Could not get technologies." }); })


    }, [rolePathSingle]);

    const handleChange = (field) => (event) => {
        setCustomer({ ...customer, [field]: event.target.value });
    };


    return (
        <>
            <div className="d-flex align-item-center">
                <div className="col-3">
                    <DefaultTextField label={"Company name"} value={customer.fullName} onChange={handleChange("fullName")} />
                </div>
                <div className="col-3">
                    <DefaultTextField label={"VAT Number"} value={customer.cif} onChange={handleChange("cif")} />
                </div>
                <div className="col-3">
                    <DefaultTextField label={"Registration Number"} value={customer.registrationNumber} onChange={handleChange("registrationNumber")} />
                </div>
                <div className="col-3">
                    <DefaultTextField label={"Phone number"} value={customer.phoneNumber} onChange={handleChange("phoneNumber")} required={false} type="number" />
                </div>
            </div>
            {customer.tmpDescription !== "" && !customer.resultTmpDescription && customer?._id &&
                <div className="d-flex justify-content-end align-items-end">
                    <Button onClick={() => { setActionType("accept"); setOpenConfirmDialog(true); }}
                        style={{ marginRight: 20, color: "#fff", background: "green", border: "none" }}
                    >
                        <CheckIcon />
                    </Button>
                    <Button onClick={() => { setActionType("reject"); setOpenConfirmDialog(true); }}
                        variant="outlined"
                        style={{ marginRight: 20, color: "#fff", background: "red", border: "none" }}
                    >
                        <ClearIcon />
                    </Button>
                </div>
            }
            <div className="d-flex align-item-center">
                <div className="col-12">
                    <DefaultTextField label={`${isAdvisorMA ? 'M&A Description' : 'Company description'}`} value={customer.tmpDescription === "" || customer.resultTmpDescription === "reject" ? customer.description : customer.tmpDescription}
                        onChange={handleChange("description")} required={false} multiline rows={4} />
                </div>
            </div>

            {isAdvisorMA &&
                <div className="d-flex align-item-center">
                    <div className="col-12">
                        <DefaultTextField label={"Company description"} value={customer.maDescription}
                            onChange={handleChange("maDescription")} required={false} multiline rows={4} />
                    </div>
                </div>
            }

            <div className="d-flex align-item-center">

                {rolePathSingle === 'advisor' &&
                    <>
                        <div className="col-4">
                            <DefaultTextField label={"Website"} value={customer.website} onChange={handleChange("website")} required={false} type="url" />
                        </div>
                        <div className="col-4">
                            <DefaultTextField label={"LinkedIn"} value={customer.linkedIn} onChange={handleChange("linkedIn")} required={false} type="url" />
                        </div>
                    </>
                }
                {rolePathSingle === 'advisor' && customer?._id && <div className="col-4">
                    <LogoSection
                        selectedLogo={selectedLogo}
                        setSelectedLogo={setSelectedLogo}
                        objectClass={customer}
                        setObjectClass={setCustomer}
                        openPreviewDialog={openPreviewDialog}
                        setOpenPreviewDialog={setOpenPreviewDialog}
                    />
                </div>}
            </div>

            <div className="d-flex align-item-center">

            </div>

            <div className="d-flex align-item-center">
                <div className="col-12 col-sm-4">
                    <Autocomplete
                        id='Countries'
                        options={countries}
                        value={customer.country || null}
                        getOptionLabel={(option) => option.name}
                        isOptionEqualToValue={(option, value) => option._id === value._id}
                        onChange={(_, newValue) => {
                            setCustomer({
                                ...customer,
                                country: newValue
                            })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label='Country'
                                margin="normal"
                                variant="outlined"
                            />
                        )}
                    />
                </div>
                <div className="col-4">
                    <DefaultTextField label={"Province"} value={customer.province} onChange={handleChange("province")} required={false} />
                </div>
                <div className="col-4">
                    <DefaultTextField label={"City"} value={customer.city} onChange={handleChange("city")} required={false} />
                </div>
            </div>

            <div className="d-flex align-item-center">
                <div className="col-4">
                    <DefaultTextField label={"Address"} value={customer.address} onChange={handleChange("address")} required={false} />
                </div>
                <div className="col-4">
                    <DefaultTextField label={"Zip Code"} value={customer.zipCode} onChange={handleChange("zipCode")} required={false} />
                </div>
                <div className="col-4">
                    {customer?.termsAccepted && (
                    <div className="d-flex align-items-center mt-3">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                        <span>
                            <strong>Terms accepted:</strong>{" "}
                            {customer?.termsAcceptedDate
                            ? format(new Date(customer.termsAcceptedDate), "dd/MM/yyyy HH:mm")
                            : "Unknown date"}
                        </span>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setOpenTermsDialog(true)}
                        >
                            View Terms of Use
                        </Button>
                        </div>
                    </div>
                    )}
                    <Dialog
                        open={openTermsDialog}
                        onClose={() => setOpenTermsDialog(false)}
                        fullWidth
                        maxWidth="md"
                        >
                        <DialogTitle>Terms of Use</DialogTitle>
                        <DialogContent dividers>
                            <div
                                dangerouslySetInnerHTML={{
                                __html: customer?.termsText || "No terms were recorded at the time of registration."
                                }}
                            />
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setOpenTermsDialog(false)} color="primary">
                            Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>


            {rolePathSingle === 'advisor' && (
                <>
                    <div className="d-flex align-item-center">
                        <div className="col-6">
                            <Autocomplete
                                id='AdvServices'
                                options={advServices}
                                value={customer.advisorService || []}
                                getOptionLabel={(option) => getNonEmpty(option.title)}
                                onChange={(_, newValue) => {
                                    setCustomer({
                                        ...customer,
                                        advisorService: newValue
                                    })
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Advisor service'
                                        margin="normal"
                                        variant="outlined"
                                    />
                                )}
                                multiple
                            />
                        </div>

                        <div className="col-6">
                            <Autocomplete
                                id='BusinessArea'
                                options={businessArea}
                                value={customer.businessArea || []}
                                getOptionLabel={(option) => getNonEmpty(option.title)}
                                onChange={(_, newValue) => {
                                    setCustomer({
                                        ...customer,
                                        businessArea: newValue
                                    })
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Business area'
                                        margin="normal"
                                        variant="outlined"
                                    />
                                )}
                                multiple
                            />
                        </div>
                    </div>

                    <div className="d-flex align-item-center">
                        <div className="col-6">
                            <Autocomplete
                                id='CountriesAd'
                                options={countries}
                                value={customer.advisorCountry || []}
                                getOptionLabel={(option) => option.name}
                                onChange={(_, newValue) => {
                                    setCustomer({
                                        ...customer,
                                        advisorCountry: newValue
                                    })
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Countries'
                                        margin="normal"
                                        variant="outlined"
                                    />
                                )}
                                multiple
                            />
                        </div>


                        <div className="col-6">
                            <Autocomplete
                                id='TechnologiesAd'
                                options={technologiesAd}
                                value={customer.advisorTech || []}
                                getOptionLabel={(option) => getNonEmpty(option.title)}
                                onChange={(_, newValue) => {
                                    setCustomer({
                                        ...customer,
                                        advisorTech: newValue
                                    })
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Technologies'
                                        margin="normal"
                                        variant="outlined"
                                    />
                                )}
                                multiple
                            />
                        </div>
                    </div>

                </>

            )
            }

            <ConfirmDialog
                title={`Are you sure you want to ${actionType} this customer description?`}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => setCustomer({ ...customer, resultTmpDescription: actionType })}
            />

        </>
    )
}